import React, {
  createContext,
  useContext,
  useState,
  useEffect,
} from 'react';
import merge from 'lodash.merge';
import { getStoreId } from '../utils/storeUtils';
import { defaultMetaData } from '../config/metaDefaults';

const MetaContext = createContext();

export const useMeta = () => {
  const context = useContext(MetaContext);
  if (!context) {
    throw new Error('useMeta must be used within a MetaProvider');
  }
  return context;
};


export const MetaProvider = ({ children }) => {
  const [metaData, setMetaData] = useState(defaultMetaData);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadMetaData = async () => {
      try {
        const storeId = getStoreId();
        const response = await fetch(`https://dnzp6dhrl0ccw.cloudfront.net/stores/${storeId}/meta.json`);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch meta data: ${response.status}`);
        }
        
        const data = await response.json();
        
        // Handle collections specially - prepend fetched collections to default ones
        const mergedData = merge({}, defaultMetaData, data);
        if (data.collections && Array.isArray(data.collections)) {
          mergedData.collections = [...data.collections, ...defaultMetaData.collections];
        }
        
        // Handle menuConfig specially - use fetched menuConfig if available, otherwise use default
        if (data.menuConfig && Array.isArray(data.menuConfig)) {
          mergedData.menuConfig = data.menuConfig;
        }
        
        setMetaData(mergedData);
      } catch (err) {
        console.error('Error loading meta data:', err);
        setError(err);
        // Keep default data
      } finally {
        setLoading(false);
      }
    };

    loadMetaData();
  }, []);

  const value = {
    metaData,
    loading,
    error
  };

  return (
    <MetaContext.Provider value={value}>
      {!loading ? children : null}
    </MetaContext.Provider>
  );
};
